import type { FC } from 'react';

import './Line.scss';

type Props = {
  title: string;
  value?: React.ReactNode;
  className?: string;
};

export const Line: FC<Props> = ({ title, value, className = '' }) => (
  <div className="line">
    <span className="left-title">{title}</span>
    {value && <span className={`right-value ${className}`}>{value}</span>}
  </div>
);
